import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl, isNotEmpty, throwErrorEvent } from '../../lib/ep.js';


import ActionButton, { SquaredButton, SecondaryButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import Input from '../builder/Input';
import FloatingLayer from '../builder/FloatingLayer';
import Model from '../builder/Model';
import SaveButton from '../builder/SaveButton';
import SectionSubtitle from '../builder/SectionSubtitle';
import SectionTitle from '../builder/SectionTitle';
import TimeCounterSimple from '../builder/TimeCounterSimple';

import PromoLabelsManager from '../promotion/PromoLabelsManager';

import { useOwner } from '../context/context.js';

import { ProfileModule } from '../ui_items/Module.js';
import RibbonCollection from '../ui_items/RibbonCollection.js';

const OwnerMainHeader = (props) => {
	const owner = useOwner();

	const promotion = owner?.promotion?.Promotion ?? false;
	const promotionType = owner?.promotion?.PromotionType ?? false;

	if(promotion === false) return null;

	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ display_internal_ref_layer, setDisplayInternalRefLayer ] = useState(false);
	const [ pm, setPm ] = useState(promotion);
	const [ previous_internal_reference, setPreviousInternalReference ] = useState(promotion.internal_ref);

	const promo_type_class = promotionType?.icon_class ?? 'knk-home';
	const promo_type_bgcolor = promotionType?.color_code ?? '#363636';
	const is_simple = props?.is_simple ?? true;
	const full_layout = props?.full_layout ?? true;

	const promo_status = owner?.status ?? 'draft';

	const protocol = `${window.location.href.split("/")[0]}//`;
	const main_promo_link = `${(props.domain != undefined && props.domain != '') ? `${protocol}${props.domain.domain}/` : window.public_url}p/${promotion.id}`;

	let promo_version_label = '';
	switch(promotion.promo_type) {
		case '0':
			promo_version_label = "Basic";
			break;

		case '1':
			promo_version_label = "Premium";
			break;

		case '2':
			promo_version_label = "White Label";
			break;
	}

	const openInternalReferenceLayer = () => {
		setPreviousInternalReference(pm.internal_ref);
		setDisplayInternalRefLayer(true);
	};

	const closeInternalReferenceLayer = (is_cancel) => {
		if(is_cancel == undefined) is_cancel = false;

		setDisplayInternalRefLayer(false);
		if(is_cancel) changePromo('internal_ref', previous_internal_reference);
	};

	const changePromo = (k, v) => {
		let promo = {...pm};
		promo[k] = v;
		setPm(promo);
	};

	const savePromo = (cb) => {
		$.post(getRemotedbUrl(`/promotions/save/${promotion.id}`), { internal_ref:pm.internal_ref }, (r) => {
			if(r.redirect_url != undefined)window.location.href = r.redirect_url;
			closeInternalReferenceLayer(false);
			if(cb != undefined) cb();
		}, 'JSON').fail((xhr, ajaxOptions, thrownError) => {
			throwErrorEvent(xhr.status);
		});
	};

	let status_label;
	let status_color = '';
	let counter_label = '';
	let num_seconds = false;
	switch(promo_status) {
		case 'active':
			status_label = i18n("***Active");
			status_color = 'green';

			if(promotion.is_published) {
				// Time to finish
				if(!promotion.is_multistage && promotion.is_pending_to_open != undefined && promotion.is_pending_to_open) {
					counter_label = "Time to start";
				} else {
					counter_label = "Time to finish";
				}
			} else {
				// Time to start
				counter_label = "Time to publish";
			}

			num_seconds = props.until_seconds;
			if(num_seconds < 0) num_seconds = false;
			break;

		case 'old':
		case 'expired':
			status_label = i18n("Expired");
			status_color = 'red';
			break;

		case 'draft':
		default:
			status_label = i18n("Draft");
			status_color = 'orange';
			break;
	}
	let promotion_title = (isNotEmpty(promotion, 'title')) ? promotion.title_clean : `[ ${i18n("Promotion")} #${promotion.id} ]`;
	let promotion_subtitle = false;
	let has_internal_ref = false;
	if(isNotEmpty(pm, 'internal_ref')) {
		has_internal_ref = true;
		promotion_subtitle = promotion_title;
		promotion_title = pm.internal_ref;
	}

	const is_agent_admin = owner?.is_agent_admin ?? true;

	let main_classes = ['gui_main_owner_header', 'gui_owner_header', 'not_columned'];
	if(full_layout) main_classes.push('is_full_layout');

	const ribbons = [{
		title:status_label,
		autotranslate:false,
		color:status_color,
		is_light:false,
	}, {
		title:<>{i18n("Version")}: <strong>{i18n(promo_version_label)}</strong></>,
		autotranslate:false,
		color:'lightgray',
		is_html:true,
	}, {
		title:<>{i18n("ID")}: <strong>#{promotion.id}</strong></>,
		autotranslate:false,
		color:'lightgray',
		is_copy:true,
		copy:promotion.id,
		tooltip_position:'bottom',
		is_html:true,
	}];

	if(is_simple) {
		main_classes.push('simple_header');

		const current_section = props?.current_section ?? false;

		return (
			<ProfileModule type='header' _class={{ other:main_classes.join(" ") }}>
				<div class="main_contents" style={{ borderColor:promo_type_bgcolor }}>
					<div class="icons">
						<ActionButton
							icon='knk-home'
							_class={{ other:'home_btn' }}
							_href={getRemotedbUrl(`/promotions/profile/${promotion.id}`)}
						>Go to home page</ActionButton>
					</div>

					<h1 class="main_title as_breadcrumbs">
						<span class={`product_icon ${promo_type_class}`}/>
						
						<span class="title">
							<ActionLink
								_href={getRemotedbUrl(`/promotions/profile/${promotion.id}`)}
								_class={{ other:'gui_cutTextOnOverflow' }}
							>{promotion_title}</ActionLink>
						</span>

						{(current_section) && (
							<span class="active_section">{i18n(current_section)}</span>
						)}
					</h1>
				</div>

				<div class="sided_header_options">
					<RibbonCollection
						items={ribbons}
						style={{ flexWrap:'nowrap' }}
					/>
				</div>
			</ProfileModule>
		)
	}

	main_classes.push('whole_header');

	return (
		<>
			<ProfileModule type='header' _class={{ other:main_classes.join(" ") }}>
				<ul class="main_contents" style={{ borderLeftColor:promo_type_bgcolor, flexGrow:'1' }}>
					<li>
						<div class={`promo_icon ${promo_type_class}`} />
					</li>

					<li style={{ flexGrow:'1' }}>
						{(has_internal_ref) ? (
							<div class="is_editable" onClick={() => openInternalReferenceLayer()}>
								<h1 class="main_title editable_content gui_cutTextOnOverflow">{i18n("Ref")}: {promotion_title}</h1>

								<SquaredButton
									icon='knk-edit'
									_class={{other:'edit_this'}}
									aria-label="Edit"
								/>
							</div>
						) : (
							<h1 class="main_title">{promotion_title}</h1>
						)}

						{(has_internal_ref) ? (
							<p class="main_subtitle">{i18n("Title")}: <strong>{promotion_subtitle.replace("&nbsp;", " ")}</strong></p>
						) : (
							<p class="main_subtitle">
								<span class="ext_ref">
									[<ActionLink
										onClick={() => openInternalReferenceLayer()}
									>Add an internal reference</ActionLink>]
								</span>
							</p>
						)}

						<RibbonCollection
							items={ribbons}
							extra_contents={(props.promo_labels != undefined) ? (
								<PromoLabelsManager
									promotion_id={promotion.id}
									shared_with_me={props.shared_with_me}
									promo_labels={props.promo_labels}
									organizers={owner.organizers}
									is_agent_admin={is_agent_admin}
									paint_wrapper={false}
								/>
							) : null}
						/>
					</li>
				</ul>

				{(promotion.is_published || num_seconds) && (
					<ButtonCollection type='nav' _class={{other:'gui_main_owner_header_actions'}}>
						<ButtonCollection>
							{(promotion.is_published) && (
								<SecondaryButton
									icon='knk-visible'
									_href={main_promo_link}
									_target="_blank"
								>Go to promotion</SecondaryButton>
							)}
						</ButtonCollection>

						{(num_seconds) && (
							<div class="gui_sided_counter gui_not_in_top_tiny">
								<TimeCounterSimple
									seconds={num_seconds}
								>{counter_label}</TimeCounterSimple>
							</div>
						)}
					</ButtonCollection>
				)}
			</ProfileModule>
								
			{(display_internal_ref_layer) && (
				<FloatingLayer backButton={() => closeInternalReferenceLayer(true)} _class={{size:'small'}}>
					<div>
						<SectionTitle>Internal reference</SectionTitle>

						<SectionSubtitle>Use the internal reference to give the promotion another name within your control panel.</SectionSubtitle>

						<SectionSubtitle>The internal reference is not public. The promotion title is.</SectionSubtitle>

						<Model model={pm} change={changePromo}>
							<Input
								max_length={50}
								_class={{size:60}}
								name="internal_ref"
							>Internal reference</Input>
						</Model>

						<ButtonCollection in_floating={true}>
							<SaveButton
								onClick={(e, cb) => savePromo(cb)}
							>Save changes</SaveButton>

							<SecondaryButton
								onClick={() => closeInternalReferenceLayer(true)}
							>Cancel</SecondaryButton>
						</ButtonCollection>
					</div>
				</FloatingLayer>
			)}
		</>
	)
}

export default injectIntl(OwnerMainHeader);